export const TICKETS_REQUEST = "TICKETS_REQUEST";
export const TICKETS_SUCCESS = "TICKETS_SUCCESS";
export const TICKETS_ERROR = "TICKETS_ERROR";

export const TICKETS_CHECKS_REQUEST = "TICKETS_CHECKS_REQUEST";
export const TICKETS_CHECKS_SUCCESS = "TICKETS_CHECKS_SUCCESS";
export const TICKETS_CHECKS_ERROR = "TICKETS_CHECKS_ERROR";